import approvedHistoryReducer from './approvedHistoryReducer'

const approvedHistoryReducers = {
    approvedHistory: approvedHistoryReducer
}

export default approvedHistoryReducers;